import { render, staticRenderFns } from "./categoryNavi.vue?vue&type=template&id=497bcbd4&scoped=true&"
import script from "./categoryNavi.vue?vue&type=script&lang=ts&"
export * from "./categoryNavi.vue?vue&type=script&lang=ts&"
import style0 from "./categoryNavi.vue?vue&type=style&index=0&id=497bcbd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497bcbd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('497bcbd4', component.options)
    } else {
      api.reload('497bcbd4', component.options)
    }
    module.hot.accept("./categoryNavi.vue?vue&type=template&id=497bcbd4&scoped=true&", function () {
      api.rerender('497bcbd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/categoryNavi.vue"
export default component.exports